var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 2.49997C8.09611 2.49997 2.49986 8.09622 2.49986 15C2.49986 21.9037 8.09611 27.5 14.9999 27.5C21.9036 27.5 27.4999 21.9037 27.4999 15C27.4999 8.09622 21.9036 2.49997 14.9999 2.49997ZM19.9999 16.25H16.2499V20C16.2499 20.69 15.6899 21.25 14.9999 21.25C14.3099 21.25 13.7499 20.69 13.7499 20V16.25H9.99986C9.30986 16.25 8.74986 15.69 8.74986 15C8.74986 14.31 9.30986 13.75 9.99986 13.75H13.7499V9.99997C13.7499 9.30997 14.3099 8.74997 14.9999 8.74997C15.6899 8.74997 16.2499 9.30997 16.2499 9.99997V13.75H19.9999C20.6899 13.75 21.2499 14.31 21.2499 15C21.2499 15.69 20.6899 16.25 19.9999 16.25Z",
    fill: "#F9B22D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.44b5e71544112bf6bc2825e793e15328.svg";
export { ForwardRef as ReactComponent };